import React, { useEffect, useState }  from 'react';
import BasicView from '../components/BasicView';
import { Redirect } from "react-router-dom";
import auth from '../../../service/Auth';
import { get_tagged_from_phenostore, analyzed_experiments } from '../../../service/apis';
import ViewError from '../components/ViewError';

const config = window.config;

const ExperimentAnalysisStatus = () => {

    const [headers, setHeaders] = useState([]);
    const [dataAnalysis, setDataAnalysis] = useState([]);
    const [errors, setErrors ] = useState("");
    const [redirectTaggedVariants, setRedirectTaggedVariants] = useState("");
    const [selectedParId, setSelectedParId] = useState("");
    const [taggedVariants, setTaggedVariants] = useState([]);
    const [summaryVariants, setSummaryVariants] = useState([]);
    const [headersTable, setHeadersTable] = useState([]);
    const [rowsTable, setRowsTable] = useState([]);
    const [loadData, setLoadData] = useState(true);

    useEffect(() => {
        // Check aoutherization
        if (auth.tokenExpired()) {
            setErrors("Logging session timeout. Please log again");
        }
        else {
            // Initialize Headers
            setHeaders([
                { label: "Experiment ID" , key: "sampleID"},
                { label: "Participant_ID", key: "participant_id" },
                { label: "Analysis Status", key: "analysis_status" },
                { label: "Causative Variant Status", key: "has_causative" },
                { label: "Solved Status", key: "solvedStatus" },
                { label: "Tagged Variants", key: "n_tagged_variants" }
            ]);  
        }
    },[])


    const loadTableData = async(state,instance) => {
        // 1. Get Analyzed Experiments
        await analyzed_experiments(auth.getToken(),config.api_endpoint)
        .then((response) => {
            return response.json()
        })
        .then((dataAnalyzed) => {
            setDataAnalysis(dataAnalyzed);
        });

        // 2. Get tagged from Phenstore
        await get_tagged_from_phenostore(auth.getToken(), config.pheno_api_endpoint)
        .then((resp) => resp.json())
        .then((json) => {
            json.summary.forEach(function(d){
                d["has_causative"] = JSON.stringify(d["has_causative"]);
                d["analysis_status"] = "false";
            });
            setSummaryVariants(json.summary);
            setTaggedVariants(json.data);
            setLoadData(false);
        })
    }
    
    const taggedVariantsCustomCell = ({value}) => {
        // Add next Page Icon
        if (value !== "") return <div >{value} <i className="fa fa-search-plus" aria-hidden="true"/> </div>;
        return <div >{value}</div>
    }

    const getTableHeaders = () => {
        // Sets headers columns for the view table
        let columns = [];
        for (let header of headers) {
            let column = {};
            if ("tooltip" in header){
                column["Header"] =  props => <span title={header.tooltip}>{header.label} <i className="fa fa-comment-o" aria-hidden="true"/></span>;
            }
            else{
                column["Header"] = header.label;
            }
            column["accessor"] = header.key;
            // Add Next Page Symbol to Tagged Variants
            if (header.key === "n_tagged_variants"){
                column["Cell"] = taggedVariantsCustomCell;
            }
            columns.push(column);
        }
        setHeadersTable(columns);
    }

    const getDataTable = () => {
        // Sets rows for the view table
        let summary = [...summaryVariants];
        if( dataAnalysis.length!== 0 && summaryVariants.length!==0 ) {
            summary.forEach(function(d){
                let sample_id = d["sampleID"];
                let found = dataAnalysis.find(s => s["RD_Connect_ID_Experiment"] === sample_id);
                if (found !== undefined)
                {
                    d["analysis_status"] = (found["analysed"] === null) ? "false" : "true" ;
                }
           });
        }
        setRowsTable(summary);
    }

    useEffect(() => {
        // Set headers
        getTableHeaders();
    },[ taggedVariants])

    useEffect(() => {
        // Set rows
        getDataTable();
    },[headersTable])
    
    const onRowClick = (state, rowInfo, column, instance) => {
        // Define a method to control Row Clicks
        return {
            onClick: e => {
                // If row is tagged_variants then Route to TaggedVariants
                if(rowInfo && column.id === "n_tagged_variants" && rowInfo.original.n_tagged_variants !== ""){
                    setRedirectTaggedVariants(rowInfo.original.sampleID);
                    setSelectedParId(rowInfo.original.participant_id);
                }
            }
        }
    };

    const closeModal = () => {
        setErrors("");   
    };

    if (errors !== "") {
        // Show popup in case an error with the loggin occurs 
        return <ViewError closeModal={closeModal} title={"Logging Error"} message={errors}/>;
    }
    else if (redirectTaggedVariants !== "") {
        // Redirect to Tagged Variants if any any row is clicked in the table
        return <Redirect to={{
            pathname:'/taggedvariants',
            experiment:redirectTaggedVariants,
            participant_id: selectedParId
        }}/>;
    }
    else {
        return (
            <div className={"mainContent"}>
                <BasicView title="List of Experiment Analysis Status"
                           headers={headers}
                           columns={headersTable}
                           data={rowsTable}
                           onFetchData={loadTableData}
                           onRowClick={onRowClick}
                           loading={loadData}
                />
            </div>
        );
    }
}

export default ExperimentAnalysisStatus;
